import ScheduleColumnManager from '../../schedules/ScheduleColumnManager';

export default class OfferSelectColumnManager extends ScheduleColumnManager {
    constructor(session, counterparty, priceCurrency) {
        super(session, counterparty, priceCurrency);

        this.settings.grouping = {
            scheduleDate: {
                groupIndex: 0,
                sortOrder: 'asc'
            }
        };

        this.priceCurrency = priceCurrency;
    }

    addWeekDayColumns(columns) {

        this.addColumn(columns, {
            alignment: 'left',
            allowEditing: false,
            allowFiltering: true,
            allowHiding: true,
            allowResizing: true,
            dataType: 'string',
            caption: 'Contract',
            dataField: 'contractDisplayName',
            visible: true,
            minWidth: 65
        });

        this.addColumn(columns, {
            alignment: 'center',
            allowEditing: false,
            allowFiltering: false,
            allowHiding: true,
            allowResizing: true,
            dataType: 'string',
            caption: 'Weekday',
            dataField: 'weekday',
            visible: false,
            width: 65
        });
    }

    addIntermediateColumns(columns) {
        super.addIntermediateColumns(columns);

        this.addColumn(columns, {
            alignment: 'center',
            allowEditing: true,
            allowFiltering: false,
            allowGrouping: false,
            allowHiding: false,
            allowResizing: false,
            dataType: 'number',
            caption: `LLH Price`,
            dataField: 'lightLoadPrice',
            format: {
                type: 'currency',
                currency: this.priceCurrency,
                precision: 2
            },
            showEditorAlways: false,
            visible: true,
            width: 50
        });

        this.addColumn(columns, {
            alignment: 'center',
            allowEditing: true,
            allowFiltering: false,
            allowGrouping: false,
            allowHiding: false,
            allowResizing: false,
            dataType: 'number',
            caption: `HLH Price`,
            dataField: 'heavyLoadPrice',
            format: {
                type: 'currency',
                currency: this.priceCurrency,
                precision: 2
            },
            showEditorAlways: false,
            visible: true,
            width: 50
        });
    }

    addQuickEntryColumns(columns) {
        super.addLlhQuickEntryColumn(columns);
        super.addHlhQuickEntryColumn(columns);

        this.addColumn(columns, {
            alignment: 'center',
            allowEditing: true,
            allowFiltering: false,
            allowGrouping: false,
            allowHiding: false,
            allowResizing: false,
            dataType: 'boolean',
            caption: 'LLH Election',
            dataField: 'isLightLoadElected',
            showEditorAlways: true,
            visible: true,
            width: 58
        });

        this.addColumn(columns, {
            alignment: 'center',
            allowEditing: true,
            allowFiltering: false,
            allowGrouping: false,
            allowHiding: false,
            allowResizing: false,
            dataType: 'boolean',
            caption: 'HLH Election',
            dataField: 'isHeavyLoadElected',
            showEditorAlways: true,
            visible: true,
            width: 58
        });
    }

    addTrailingColumns(columns) {
        super.addTrailingColumns(columns);

        this.addColumn(columns, {
            alignment: 'center',
            allowEditing: false,
            allowFiltering: false,
            allowGrouping: false,
            allowHiding: true,
            allowResizing: true,
            caption: 'Total (Hours)',
            dataField: 'totalH',
            dataType: 'number',
            format: this.formatNumber.bind(this),
            visible: false,
            width: 56
        });

        this.addColumn(columns, {
            alignment: 'center',
            allowEditing: false,
            allowFiltering: false,
            allowGrouping: false,
            allowHiding: true,
            allowResizing: true,
            caption: 'Total (MWh)',
            dataField: 'totalMWh',
            dataType: 'number',
            format: this.formatNumber.bind(this),
            visible: true,
            width: 52
        });
    }

    getColumnCssClass() {
      return 'pwx-alert-overlay-none pwx-flag-none pwx-select-none pwx-state-normal pwx-highlight-none pwx-cell-standard offer-select';
    }
}